import { createOpportunitiesEvent } from './requests'
import {
  OPP_ENUM_FILTER,
  OPPORTUNITY_CLIENT_EVENT_FILTER_FIELDS,
  OPPORTUNITY_CLIENT_EVENT_TARGET_KIND,
  OPPORTUNITY_TYPE_ENUM,
  TOpportunitiesV3EventFilterField,
  TOpportunitiesV3EventFilters,
  TOpportunitiesV3EventPayload,
  TOpportunitiesV3EventTargetKind,
  TOpportunitiesV3Type
} from './types'

export type TOpportunitiesV3EventFiltersInput = {
  yearMonth?: string | number
  kind?: OPP_ENUM_FILTER
  search?: string
  priority: string[]
  public_rating: string[]
  fidelity: string[]
  segment: string[]
  network: string[]
  subsidiary: string[]
  user_std_code: string[]
}

export const parseOpportunityYearMonth = (value?: string | number): number | undefined => {
  if (value === undefined || value === '') {
    return undefined
  }

  const parsed = typeof value === 'number' ? value : Number(value)

  if (!Number.isFinite(parsed) || parsed <= 0) {
    return undefined
  }

  return parsed
}

export const buildOpportunityClientEventFilters = (
  input: TOpportunitiesV3EventFiltersInput
): TOpportunitiesV3EventFilters => {
  const filters: TOpportunitiesV3EventFilters = {
    priority: input.priority,
    public_rating: input.public_rating,
    fidelity: input.fidelity,
    segment: input.segment,
    network: input.network,
    subsidiary: input.subsidiary,
    user_std_code: input.user_std_code
  }

  const yearMonth = parseOpportunityYearMonth(input.yearMonth)

  if (yearMonth !== undefined) {
    filters.year_month = yearMonth
  }

  if (input.kind !== undefined) {
    filters.kind = input.kind
  }

  if (input.search !== undefined) {
    filters.search = input.search
  }

  return filters
}

export const isOpportunityClientEventFilterField = (
  field: string
): field is TOpportunitiesV3EventFilterField =>
  (OPPORTUNITY_CLIENT_EVENT_FILTER_FIELDS as readonly string[]).includes(field)

export const mapOpportunityTypeToEventTargetKind = (
  type: TOpportunitiesV3Type
): TOpportunitiesV3EventTargetKind => {
  if (type === OPPORTUNITY_TYPE_ENUM.ACTIVE_BASE) {
    return OPPORTUNITY_CLIENT_EVENT_TARGET_KIND.ACTIVE_BASE
  }

  return OPPORTUNITY_CLIENT_EVENT_TARGET_KIND.ODC
}

export const trackOpportunityClientEvent = (payload: TOpportunitiesV3EventPayload): void => {
  createOpportunitiesEvent(payload).catch(() => undefined)
}
